<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="tp">
<h1 class="bk">Unfreedom</h1>
<h1 class="bk1">Slavery and Dependence in Eighteenth-Century Boston</h1>
<p class="bkau">Jared Ross Hardesty</p>
<p class="bkpub">New York University Press</p>
<p class="bkpub1">New York and London</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hardesty-0003.vue?7bec9cef